var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.course.rigid_pricing_rules
    ? _c("div", { staticClass: "mt-3" }, [
        _c("label", { attrs: { for: "quantity" } }, [
          _c("small", [
            _vm._v(_vm._s(_vm._f("translate")("Licence quantity"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.quantity,
                expression: "quantity",
              },
            ],
            staticClass: "form-select mb-3",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.quantity = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          _vm._l(_vm.course.price_list, function (priceItem) {
            return _c(
              "option",
              {
                key: priceItem.id,
                domProps: { value: priceItem.activatesAfter },
              },
              [_vm._v("\n      " + _vm._s(priceItem.activatesAfter) + "\n    ")]
            )
          }),
          0
        ),
      ])
    : _vm.course.type === "physical"
    ? _c("div", { staticClass: "d-flex align-items-center my-3" }, [
        _c("label", { attrs: { for: "quantity" } }, [
          _c("small", [_vm._v(_vm._s(_vm._f("translate")("Quantity")) + ": ")]),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.quantity,
              expression: "quantity",
            },
          ],
          staticClass: "form-control form-control-sm w-25 ms-3",
          attrs: {
            id: "quantity",
            name: "quantity",
            min: "1",
            max: "9999",
            step: "1",
            type: "number",
          },
          domProps: { value: _vm.quantity },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.quantity = $event.target.value
            },
          },
        }),
      ])
    : _c("div", { staticClass: "my-3" }, [
        _c("label", { attrs: { for: "quantity" } }, [
          _c("small", [
            _vm._v(_vm._s(_vm._f("translate")("Licence quantity"))),
          ]),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.quantity,
              expression: "quantity",
            },
          ],
          staticClass: "form-control",
          attrs: {
            name: "quantity",
            min: "1",
            max: "9999",
            step: "1",
            type: "number",
          },
          domProps: { value: _vm.quantity },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.quantity = $event.target.value
            },
          },
        }),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }